import { cachePdfData } from "@/apis/pdf-api"
import { getThisMonthWaterBill } from "@/routes/apt/[apt_code]/water-bill-util"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import dayjs from "dayjs"
import { create } from "zustand"
import { getLeakRawAPI } from "@/apis/apt-api"

export const pdfStore = create((set, get) => ({
  open: false,
  row: null,
  pdfId: null,

  openModal: (row) => set({ open: true, row }),

  closeModal: () => set({ open: false, row: null }),

  info: {
    apt: "",
    dong: "",
    ho: "",
    usage: 0,
    leak: 0,
    leakRate: 0,
    leakStartAt: "",
    totalBill: 0,
    leakBill: 0,
    billPercent: 0
  },

  series: [],
  xLabels: [],

  setInfo: (region = "cheongju", info) => {
    const { usage, leak } = info

    const leakRate = usage > 0 ? ((leak / usage) * 100).toFixed(1) : 0

    const totalBill = getThisMonthWaterBill(region, usage)

    const leakBill = getThisMonthWaterBill(region, leak, true)

    const billPercent = totalBill > 0 ? ((leakBill / totalBill) * 100).toFixed(1) : 0

    set({
      info: {
        ...info,
        usage: usage.toFixed(2),
        leak: leak.toFixed(2),
        leakRate,
        totalBill: totalBill.toLocaleString(),
        leakBill: leakBill.toLocaleString(),
        billPercent
      }
    })
  },

  setChart: (usageData, leakData, xLabels) => {
    const usageSeries = {
      color: "#4caefe",
      data: usageData,
      name: "usage"
    }

    const leakSeries = {
      color: "#ED561B",
      data: leakData,
      name: "leakAmount"
    }

    const noleakSeries = {
      color: "#999",
      data: leakData.map((d) => (d > 0 ? null : d)),
      name: "leakAmount"
    }

    set({
      series: [usageSeries, leakSeries, noleakSeries],
      xLabels
    })
  },

  getPdf: async ({ dong, ho, leakStartAt }) => {
    const { sido, kapt_code, apt_name, ended_at } = aptSearchStore.getState().pickApt
    const end_date = ended_at ? dayjs(ended_at) : dayjs()

    const currentDay = end_date.date()

    let start_date

    // INFO: 월 초반
    // TODO: 데이터가 모자라므로 지난달의 7일치 데이터를 가져온다.
    if (currentDay <= 14) {
      start_date = end_date.startOf("month").subtract(7, "day")
    } else {
      start_date = end_date.startOf("month")
    }

    const { setChart, setInfo } = get()

    const { x_labels, datasets, summary } = await getLeakRawAPI({
      sido,
      kapt_code,
      dong,
      ho,
      start_date: start_date.format("YYYY-MM-DD"),
      end_date: end_date.format("YYYY-MM-DD")
    })

    setChart(datasets.usages, datasets.leaks, x_labels)

    const region = kapt_code.split("-")[1]
    setInfo(region, {
      apt: apt_name,
      dong: +dong,
      ho: +ho,
      usage: summary.monthly_usage,
      leak: summary.monthly_leak,
      leakStartAt
    })

    // INFO: 최신 state 가져오기
    const { info, series, xLabels } = get()

    // INFO: 서버 cache 저장
    // ! PDF 저장 용도
    const { pdf_id } = await cachePdfData({ info, series, xLabels })
    set({ pdfId: pdf_id })

    return true
  }
}))
